import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

/**
 * Renders a PDF to view
 * @param param0 - The props
 * @returns
 */
// eslint-disable-next-line import/prefer-default-export
export function PDFViewer({ loadingPdf, pdfUrl }: { loadingPdf: boolean, pdfUrl: string }) {
  return (
    <Box sx={{ height: '66%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{
        flex: 1, p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center',
      }}
      >
        {loadingPdf && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CircularProgress sx={{ color: '#4682B4', mb: 2 }} />
          <Typography variant="body2" color="text.secondary">
            Loading PDF...
          </Typography>
        </Box>
        )}
        {!loadingPdf && pdfUrl && (
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          style={{ border: 'none', borderRadius: '4px' }}
          title="Vendor Statement PDF"
        />
        )}
        {!loadingPdf && !pdfUrl && (
        <Typography variant="body2" color="text.secondary">
          PDF not available
        </Typography>
        )}
      </Box>
    </Box>
  );
}
